import { createContext, type ReactNode, useContext, useMemo, useState } from 'react';

import type { ScoreUnit } from './types';

type ScoreUnitContextValue = {
  scoreUnit: ScoreUnit;
  setScoreUnit: (unit: ScoreUnit) => void;
};

const ScoreUnitContext = createContext<ScoreUnitContextValue | undefined>(undefined);

export function ScoreUnitProvider({
  children,
  initialUnit = 'proficiency_level',
}: {
  children: ReactNode;
  initialUnit?: ScoreUnit;
}) {
  const [scoreUnit, setScoreUnit] = useState<ScoreUnit>(initialUnit);

  const value = useMemo(() => ({ scoreUnit, setScoreUnit }), [scoreUnit]);

  return <ScoreUnitContext.Provider value={value}>{children}</ScoreUnitContext.Provider>;
}

export function useOptionalScoreUnit(): ScoreUnitContextValue | undefined {
  return useContext(ScoreUnitContext);
}

export function useScoreUnit(): ScoreUnitContextValue {
  const ctx = useContext(ScoreUnitContext);
  if (!ctx) {
    throw new Error('useScoreUnit must be used inside <ScoreUnitProvider>');
  }
  return ctx;
}
